import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { JacketView } from '@bibliocommons/deprecated-base-icons';
import { DefaultButton } from '@bibliocommons/deprecated-base-buttons';
import cn from 'classnames';

const JacketViewButton = ({ currentView, toggleListView, className }) => {
  const isActive = currentView === 'medium' ? 'active' : '';
  const toggleView = () => toggleListView('medium');

  const btnClasses = cn(className, { active: currentView === 'medium' });

  return (
    <FormattedMessage id="jacket_view" values={{ isActive: isActive ? 'yes' : 'no' }}>
      {message => (
        <DefaultButton
          data-test-id="jacket-view-button"
          flat
          className={btnClasses}
          handleClick={toggleView}
          title={message}
        >
          <JacketView />
          <ScreenReaderMessage>{message}</ScreenReaderMessage>
        </DefaultButton>
      )}
    </FormattedMessage>
  );
};

JacketViewButton.propTypes = {
  className: PropTypes.string,
  currentView: PropTypes.string.isRequired,
  toggleListView: PropTypes.func.isRequired
};

export default JacketViewButton;
